import ListEdit from "../UI/ListEdit";
import {Link, useNavigate} from "react-router-dom";
import React, {Fragment, useState} from "react";
import Box from "../UI/Box";
import {useCustomerFilterCustomers} from "../../hooks/useCustomerFilterCustomers";

const CustomerFilterCustomerList = (props) => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const {customerFilter, customerFilterCustomers, pagination} = useCustomerFilterCustomers(props.customerFilterId, page, pageSize, 0);

    const listHeaders = [
        'Customer name',
    ];

    const columns = {
        functionParams : [
            'customerId'
        ],
        dataKeys       : [
            'name'
        ]
    }


    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const handleCheckboxSubmit = (selectedIds) => {
        navigate('/customer-thematics', { state: { customerIds: selectedIds } });
    };


    return (
        <Fragment>
            <Link to={'/customer-filters'}>Back</Link>
            <Box>
                {customerFilter && <h1>Customer filter: {customerFilter.name}</h1>}
                <ListEdit
                    headers={listHeaders}
                    items={customerFilterCustomers}
                    columns={columns}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                    checkbox={{
                        buttonTitle: 'Use in Figure Progress Tracker',
                        buttonHandler: handleCheckboxSubmit
                    }}
                />
            </Box>
        </Fragment>

    );
};

export default CustomerFilterCustomerList;